module.exports = __webpack_public_path__ + "img/creative-portfolio.7976dbc0.png";